





































































































/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue, Prop } from "vue-property-decorator";
import { EventBus } from "../event-bus";
import axios from "axios";
import { Token } from "../utils/Token";
import {License} from "@/models/License";

@Component({
  components: {},
})
export default class LicenseModal extends Vue {
  @Prop() readonly value!: boolean;
  private licenseInfo: License=new License("",0);
  private DeviceListFlag=false;

  private errorModalFlag = false;
  private errorText = "";
  private errorTitle = "Error";

  private fileToUpload:any=null;
 
  private flag=true;
  private headers=[
          { text: 'Vendor Id',value: 'VendorId',sortable: false,align: 'start'},
          { text: 'Product Id', value: 'ProductId',sortable: false},
        ];
        

  created() {
//    console.log("license created",this.config);
    EventBus.$on("openLicenseModal",(licenseInfo:License) => {      
      this.licenseInfo=licenseInfo;
    });
  }
  

  get show() {
    return this.value;
  }
  set show(value: boolean) {
    this.DeviceListFlag=false;
    EventBus.$emit("closeLicenseModal", value);
  }

//first upload the file
//and then parse it to get license info
  private async UpdateLicenseFunction(){
    const token = await Token.getTokenWithExpiry("token");
    const formData = new FormData();
    formData.append('file', this.fileToUpload);
    ////EventBus.$emit("BeginLoader",null );   
    
    axios({
      method: "post",
      withCredentials: true,
      url: `${process.env.VUE_APP_BASE_URL}/file`,
      data:formData,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-type": "multipart/form-data",
      },
    })
      .then((response) => {
        if (response.data.code == 401) {
          EventBus.$emit("LogOutEventBus", false);
        } else {
          this.flag=false;
          if (response.data.code == 200) {

            const res=this.ParseLicense(token,this.fileToUpload.name);
            res.then((result)=>this.flag=result)
            .then(()=>{
            const snackbarData = {
                text:
                  this.flag === true
                    ? "File Uploaded. License Updated."
                    : "Error: File not uploaded.License not Updated.",
                color: this.flag === true ? "#4caf50" : "#2196f3",
                };
            EventBus.$emit("showSnackbar", snackbarData);
            })
            .catch((error) => {console.log(error)});      

          }
          ////EventBus.$emit("FinishLoader",null );   
        }
        
      })
      .catch((err) => {
        ////EventBus.$emit("FinishLoader",null );   

        console.log("error:", err);
      });
      
    }

  //POST("/api/license)
  private async ParseLicense(token:any,name:string):Promise<boolean>{
    let result=false;
    await axios({
      method: "post",
      withCredentials: true,
      url: `${process.env.VUE_APP_BASE_URL}/license`,
      data:{name:name},
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-type": "application/json",
      },
    })
      .then((response) => {
        if (response.data.code == 401) {
          EventBus.$emit("LogOutEventBus", false);
        } else {
          result= false;
          if (response.data.code == 200) {
            const items = response.data;
            //console.log("claims",items);
            //first get data and put them in license info and then broadcast the version
            this.licenseInfo=new License(items.version,items.numOfClients, items.deviceslicense);
            this.$store.dispatch('updateVersion', this.licenseInfo.Version);
            this.DeviceListFlag=true;
            result= true;
          }
        }
        })
      .catch((err) => {
        console.log("error:", err);
        ////EventBus.$emit("FinishLoader",null );   
        result= false;
      });
        return result;
      }

  
  private cancelModal() {
    this.DeviceListFlag=false;
    EventBus.$emit("closeLicenseModal", false);
  }
}
